var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dollar badge 2 - Iconly Pro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.34828 4.771V8.21688V14.8059C7.34828 15.9571 6.37693 16.8896 5.17773 16.8896H15.2926C17.0293 16.8896 17.9926 15.7664 17.9926 13.952L17.9999 4.771C17.9999 4.10705 17.3383 3.67583 16.7643 3.95838L16.2202 4.23392C15.8958 4.3966 15.5213 4.40361 15.1823 4.26195L13.645 3.60499C13.0199 3.34423 12.3283 3.34423 11.7032 3.60499L10.1658 4.26195C9.82692 4.40361 9.4515 4.3966 9.128 4.23392L8.58395 3.95838C8.0099 3.67583 7.34828 4.11405 7.34828 4.771Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8035 8.25146H11.9646C11.4181 8.25146 10.9746 8.67726 10.9746 9.2019C10.9746 9.72726 11.4181 10.1523 11.9646 10.1523H13.0964C13.6429 10.1523 14.0864 10.5781 14.0864 11.1034C14.0864 11.6281 13.6429 12.0538 13.0964 12.0538H11.2575",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5293 12.0534V12.8512M12.5293 7.44849V8.25333",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.17784 16.8894C4.57459 16.8894 4.03054 16.6566 3.64054 16.2822C3.24324 15.9008 3 15.3778 3 14.8056V9.00752C3 8.34354 3.66243 7.91309 4.23648 8.19564L4.78054 8.47118C5.10406 8.63384 5.47946 8.64088 5.81757 8.49921L6.85541 8.05475C6.93568 8.01895 7.14243 8.1108 7.34837 8.21666",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBadge);
export default __webpack_public_path__ + "static/media/dollar_badge.e6b051e417225bae5566b7431412e749.svg";
export { ForwardRef as ReactComponent };